import React from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { bewizrLibraryStore } from '~/stores'
import { observer } from '~/ui/component'
import { HBox, PushButton } from '~/ui/components'
import { AppLayoutConfig } from '~/ui/layouts'
import BeWizrLibraryView from './BeWizrLibraryView'
import BeWizrCalendarView from './BeWizrCalendarView'
import { layout } from '~/ui/styling'

export type Props = RouteComponentProps

const BeWizrCalendarScreen = observer('BeWizrCalendarScreen', (props: Props) => {

  const [t] = useTranslation('bewizr-library')

  const endpoint           = bewizrLibraryStore.allCalendarItems
  const topicID            = endpoint.param('topic')
  const topicDocument      = topicID == null ? null : bewizrLibraryStore.topics.document(topicID)
  const topicsEndpint      = bewizrLibraryStore.allTopics
  const categoriesEndpoint = topicDocument?.categoriesEndpoint

  //------
  // Rendering

  function render() {
    return (
      <>
        <AppLayoutConfig
          title={t('calendar.title')}
          ActionsComponent={renderActions}
        />
        <BeWizrLibraryView
          endpoint={endpoint}
          renderList={props => <BeWizrCalendarView {...props}/>}
          filters={{
            type:     ['learning_track', 'occurrence'],
            topic:    {endpoint: topicsEndpint},
            category: categoriesEndpoint == null ? false : {endpoint: categoriesEndpoint},
          }}
        />
      </>
    )
  }

  function renderActions() {
    return (
      <HBox gap={layout.padding.inline.s}>
        <PushButton
          icon='unordered-list'
          caption={t('calendar.show_list')}
          href='/bewizr-library'
          small
        />
      </HBox>
    )
  }

  return render()

})

export default BeWizrCalendarScreen